import {z as zod} from "zod";

export type SubscriptionWorkspaceCapabilityConfiguration = Record<string, never>;

export const subscriptionWorkspaceCapabilityConfigurationValidator: zod.ZodType<SubscriptionWorkspaceCapabilityConfiguration> =
    zod.strictObject({});
